module.exports = __webpack_public_path__ + "img/herb-tarragon-190x100.57c56866.jpg";